import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import selector from 'modules/Auth/selectors.js'
import corporateRequest from 'utils/corporateRequest'

export const SET_TPO_METRICS = 'corporate/SET_TPO_METRICS'
export const SET_TPO_USER_LIST = 'corporate/SET_TPO_USER_LIST'
export const SET_TPO_FILTER = 'corporate/SET_TPO_FILTER'
export const setTpoMetrics = data => {
  return {
    type: SET_TPO_METRICS,
    data,
  }
}

export const setTpoUserList = data => {
  return {
    type: SET_TPO_USER_LIST,
    data,
  }
}

export const setTpoFilter = data => {
  return {
    type: SET_TPO_FILTER,
    data,
  }
}

export const getTPOMetrics = instituteId => async (dispatch, getState) => {
  try {
    const state = getState()
    const instituteCampusId =
      selector.getInstituteDetails(state)?.id || instituteId
    if (instituteCampusId) {
      const response = await corporateRequest.get(
        `/corporate/institute/${instituteCampusId}/requestMetrics`
      )
      dispatch(setTpoMetrics(response?.data?.data || {}))
      return response
    }
  } catch (error) {
    return error
  }
}

export const getTpoUserList =
  (
    flag = 'PENDING',
    pageNo = 0,
    pageLimit = 10,
    search,
    sortBy,
    order = 'DESC',
    selectedCompany,
    selectedPriorities,
    selectedRoles,
    selectedRules
  ) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      const updatedPayload = {
        flag,
        pageNo: pageNo,
        pageLimit: pageLimit,
        ...(search === null ? {} : { search: search.trim() }),
        ...(sortBy === '' ? {} : { sortBy: sortBy }),
        order: order === 'ascend' ? 'ASC' : order === 'descend' ? 'DESC' : '',
        ...(selectedRoles?.length === 0 ? {} : { role: selectedRoles?.flat() }),
        ...(selectedCompany?.length === 0
          ? {}
          : { company: selectedCompany?.map(item => item?.join(',')) }),
        ...(selectedRules?.length === 0 ? {} : { reasonFilter: selectedRules }),
        ...(selectedPriorities?.length === 0
          ? {}
          : { priorityFilter: selectedPriorities }),
      }

      const response = await corporateRequest.post(
        `/corporate/institute/${instituteCampusId}/requestList`,
        updatedPayload
      )

      return response
    } catch (error) {
      console.error('Error fetching TPO user list:', error)
      ErrorMessage('Error fetching roles, Try again.')

      return false
    }
  }

export const updateAllRequestList =
  (
    flag = 'PENDING',
    selectedStudentRoles = [],
    selectAll = false,
    tpoStatus = 1,
    isApplied = 1,
    search
  ) =>
  async (dispatch, getState) => {
    try {
      const state = getState()

      const instituteCampusId = selector.getInstituteDetails(state)?.id

      // const tpoStatus = flag === 'PENDING' ? 1 : -1
      // const isApplied = flag === 'PENDING' ? 1 : 0

      const filteredSelectedStudentRoles = selectedStudentRoles.filter(
        item => item.studentId && item.roleId
      )

      const payload = {
        flag,
        tpoStatus,
        isApplied,
        SelectedStudentRole: selectAll ? [] : filteredSelectedStudentRoles,
        selectAll:
          filteredSelectedStudentRoles.length < 1 || selectAll ? true : false,
        search,
      }

      const response = await corporateRequest.put(
        `/corporate/institute/${instituteCampusId}/updaterequest`,
        payload
      )
      return response?.data
    } catch (err) {
      console.error('API Error:', err)
      ErrorMessage('Error fetching roles, Try again.')
      throw err
    }
  }

export const getConsentDrawerList = (studentId, updatedPayload) => async () => {
  try {
    const response = await corporateRequest.post(
      `/corporate/student/${studentId}/requestDrawer`,
      updatedPayload
    )

    return response
  } catch (error) {
    console.error('Error fetching TPO user list:', error)
    ErrorMessage('Error fetching roles, Try again.')

    return false
  }
}
export const getTPOFilter =
  (Pending, companySearchValue, roleSearchValue) =>
  async (dispatch, getState) => {
    try {
      const state = getState()
      const instituteCampusId = selector.getInstituteDetails(state)?.id
      let queryFilter = `flag=${Pending}&roleSearch=${roleSearchValue}&companySearch=${companySearchValue}`
      const response = await corporateRequest.get(
        `/corporate/institute/${instituteCampusId}/requestFilter?${queryFilter}`
      )

      dispatch(setTpoFilter(response.data.data))

      return response.data.data
    } catch (error) {
      console.error('Error in getTPOFilter:', error)
      return error
    }
  }
